import React, { createContext, useContext, useEffect, useRef } from "react";
import { CommandBar, SearchBox } from "@fluentui/react";
import { Empty, notification, Skeleton, Tooltip, Button } from "antd";
import moment from "moment";
import { SubPageHeaderTitle } from "../../../../shared/SubPageHeaderTitle";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import WrfmSettingStore from "../../store/wrfmsettingstore";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { PlusOutlined } from "@ant-design/icons";
import { commaFormating } from "../../../../Utility/modules/helpers";
const wrfmStoreCtx = createContext(WrfmSettingStore);
export const FlowstationCapacity = observer(() => {
  useEffect(() => {
    async function loadOperatingCapacity() {
      try {
        await wrfmStore.loadOperatingCapacity();
      } catch (error) {
        notification.error({
          message: "Feedback Manager",

          description: `Something went wrong.${error.message}.`,
        });
      }
    }
    loadOperatingCapacity();
  }, []);

  const capacityGrid = useRef(null);
  const wrfmStore = useContext(wrfmStoreCtx);
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        width: 80,
        checkboxSelection: true,
        pivot: false,
        resizable: true,
      },
      {
        field: "year",
        headerName: "Operating Year",
        resizable: true,
        width: 100,
      },
      {
        field: "flowstation",
        headerName: "Flowstation",
        resizable: true,
      },
      {
        field: "oilCapacity",
        headerName: "Oil Operating Design Capacity(bopd)",
        resizable: true,
        valueFormatter: commaFormating,
      },
      {
        field: "gasCapacity",
        headerName: "Gas Operating Design Capacity(mscfd)",
        resizable: true,
        valueFormatter: commaFormating,
      },
      {
        headerName: "AUDIT",

        children: [
          {
            headerName: "Uploaded(Modified) By",
            field: "uploadedBy",
            filter: true,
            sortable: true,
            resizable: true,
          },
          {
            headerName: "Uploaded On",
            field: "uploadedOn",
            sortable: true,
            resizable: true,
            filter: true,
            cellRendererFramework: function (props) {
              return moment(props.data.uploadedOn).format(
                "ddd DD.MM.YYYY , h:mm:ss a"
              );
            },
          },
        ],
      },
    ],
  };

  const rowSelected = (grid) => {
    wrfmStore.disableCommand = false;
    const selrow = grid.api.getSelectedNodes()[0];
    if (selrow) {
      wrfmStore.selMapping = toJS(selrow.data);
      console.log(wrfmStore.selMapping);
    }
  };
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{ borderRight: "1px solid #F0F2F5", marginRight: "5px" }}
    >
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <SubPageHeaderTitle title="Flowstation Field Mappings" />
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CommandBar
            items={[
              {
                key: "filtert356",

                text: "Modify Operating Capacity",
                disabled: wrfmStore.disableCommand,
                onClick: (ev) => {
                  wrfmStore.showMappingDialog = true;
                  wrfmStore.action = "Modify";
                },
              },
              {
                key: "filtertj",

                text: "Remove",
                disabled: true, // wrfmStore.disableCommand,
              },
            ]}
            farItems={[
              {
                key: "addbtn",
                onRender: () => (
                  <Tooltip title="Add New flowstation to field mapping">
                    <Button
                      shape="circle"
                      icon={<PlusOutlined />}
                      type="primary"
                      onClick={(ev) => {
                        let initMap = {
                          flowstationId: null,
                          flowstationName: "",
                          fieldId: null,
                          fieldName: "",
                        };

                        wrfmStore.selMapping = initMap;
                        wrfmStore.showFlowsationCapcityDialog = true;

                        wrfmStore.action = "Add";
                      }}
                    />
                  </Tooltip>
                ),
              },
            ]}
          />
        </div>
      </div>

      {wrfmStore.isLoading ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <div
          className="ag-theme-balham"
          style={{
            minHeight: "50vh",
            height: "70vh",
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          {wrfmStore.operatingCapacities.size > 0 ? (
            <AgGridReact
              ref={capacityGrid}
              rowData={[...wrfmStore.operatingCapacities.values()]}
              onSelectionChanged={rowSelected}
              columnDefs={gridcolumnDefs.columnDefs}
              gridOptions={{
                defaultColDef: {
                  sortable: true,
                  filter: true,
                  enableValue: true,
                  enableRowGroup: true,
                  enablePivot: true,
                },
                enableCharts: true,
                enableRangeSelection: true,

                rowSelection: "single",
                pagination: true,
                columnDefs: gridcolumnDefs.columnDefs,
                animateRows: true,
                statusBar: {
                  statusPanels: [
                    {
                      statusPanel: "agTotalRowCountComponent",
                      align: "center",
                    },
                  ],
                },
                columnTypes: {
                  numberColumn: {
                    width: 130,
                    filter: "agNumberColumnFilter",
                  },
                  medalColumn: {
                    width: 100,
                    columnGroupShow: "open",
                    filter: false,
                  },
                  nonEditableColumn: { editable: false },
                  dateColumn: {
                    filter: "agDateColumnFilter",
                    filterParams: {
                      comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                      ) {
                        var dateParts = cellValue.split("/");
                        var day = Number(dateParts[0]);
                        var month = Number(dateParts[1]) - 1;
                        var year = Number(dateParts[2]);
                        var cellDate = new Date(year, month, day);
                        if (cellDate < filterLocalDateAtMidnight) {
                          return -1;
                        } else if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        } else {
                          return 0;
                        }
                      },
                    },
                  },
                },
              }}
              rowSelection="single"
              copyHeadersToClipboard={true}
              overlayLoadingTemplate={`${(
                <span class="ag-overlay-loading-center">
                  Please wait while your rows are loading
                </span>
              )}`}
              overlayNoRowsTemplate={
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
              }
            ></AgGridReact>
          ) : (
            <Empty />
          )}
        </div>
      )}
    </div>
  );
});

